<template>
  <div class="chapter-detail-filedown">
    <img src="../../../../static/img/file-other.png" alt="" />
    <span class="tips">{{ fileTitle }}</span>
    <div class="homeBtn" @click="backHome">下载</div>
  </div>
</template>

<script>
import global from "@/common/js/global.js";
export default {
  props: {
    fileTitle: {
      type: String,
      default: function() {
        return "";
      }
    },
    fileUrl: {
      type: String,
      default: function() {
        return "";
      }
    }
  },
  methods: {
    backHome() {
      if (this.fileUrl.indexOf("http" == 0)) {
        window.location.href = this.fileUrl;
      } else {
        window.location.href = global.imgUrl + this.fileUrl;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.chapter-detail-filedown {
  min-height: calc(100vh - 80px);
  padding: 30px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 16px;
  color: white;
  background-color: #525659;
  img {
    margin-bottom: 20px;
  }
  .tips {
    margin-bottom: 20px;
    font-size: 14px;
    font-weight: bold;
    line-height: 32px;
    letter-spacing: 1.82px;
    color: #ffffff;
  }
  .homeBtn {
    margin-bottom: 20px;
    width: 90px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    opacity: 0.6;
    border-radius: 3px;
    background-color: #000000;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/chapter-details/chapter-detail/chapter-detail-fileDown.vue